import RowTable from './RowTable';

export { RowTable } from './RowTable'
export default RowTable;


// WEBPACK FOOTER //
// ./src/components/TaskTable/RowTable/index.js